import { Form } from "react-bootstrap";

const FirstStepMobile = ({firstStep, updateMultipleValues}) => {


    const handleChange = (e) => {
        const values = {...firstStep};
        
        if (e.target.type === "radio") {
            values[e.target.id] = e.target.value;
        }
        else {
            values[e.target.id] = parseInt(e.target.value);
        }
        updateMultipleValues({firstStep: values});
    }
    return (
      <>
        <div className="first-step-mobile-main-container mx-auto position-relative" onChange={(e) => handleChange(e)}>
        <div className="title mb-4">
            <h1 className="text-start register-text" style={{fontSize: 24, marginBottom: 15}}>Background information</h1>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">What best describes your gender? *</Form.Label>
                <Form
                    onSubmit={(e) => console.log("handle submit")}
                    style={{fontSize: 14, textAlign: "left" }}
                >
                <Form.Check // prettier-ignore
                    value={"Female"}
                    type={"radio"}
                    id={`gender`}
                    label={`Female`}
                    name="group1"
                    checked={firstStep?.gender === 'Female'}
                />
                <Form.Check // prettier-ignore
                    value={"Male"}
                    type={"radio"}
                    id={`gender`}
                    label={`Male`}
                    name="group1"
                    checked={firstStep?.gender === 'Male'}
                />
                <Form.Check // prettier-ignore
                    value={`Non-binary`}
                    type={"radio"}
                    id={`gender`}
                    label={`Non-binary`}
                    name="group1"
                    checked={firstStep?.gender === 'Non-binary'}
                />
                <Form.Check // prettier-ignore
                    value={`Unsure how to describe myself`}
                    type={"radio"}
                    id={`gender`}
                    label={`Unsure how to describe myself`}
                    name="group1"
                    checked={firstStep?.gender === 'Unsure how to describe myself'}
                />
                <Form.Check // prettier-ignore
                    value={`Prefer not to say`}
                    type={"radio"}
                    id={`gender`}
                    label={`Prefer not to say`}
                    name="group1"
                    checked={firstStep?.gender === 'Prefer not to say'}
                />
                <Form.Check // prettier-ignore
                    value={"Other"}
                    type={"radio"}
                    id={`gender`}
                    label={`A gender not listed here`}
                    name="group1"
                    checked={firstStep?.gender === 'Other'}
                />{firstStep["gender"] === "Other" && <Form.Control
                placeholder="Type the gender"
                required
                id="gender_other"
            />}
                </Form>
                <Form.Control.Feedback type="invalid">
                    Please provide a title.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">What is your age? *</Form.Label>
                <Form.Control
                    placeholder=""
                    // value={summary}
                    required
                    id="age"
                    value={firstStep?.age}
                    // onChange={(e) => setSummary(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">Your host university </Form.Label>
                <Form.Control
                    placeholder="Host university name"
                    // value={moreInfo}
                    required
                    value={firstStep?.host_schac}
                    disabled
                    // onChange={(e) => setMoreInfo(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">The title of the course you are currently filling in this evaluation for </Form.Label>
                <Form.Control
                    placeholder="Introduction to communication"
                    // value={moreInfo}
                    required
                    value={firstStep?.course_title}
                    disabled
                    // onChange={(e) => setMoreInfo(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">Your home university </Form.Label>
                <Form.Control
                    placeholder="Home university name"
                    // value={moreInfo}
                    required
                    value={firstStep?.home_schac}
                    disabled
                    // onChange={(e) => setMoreInfo(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">Your study field </Form.Label>
                <Form.Control
                    placeholder="Study field title"
                    // value={moreInfo}
                    required
                    // onChange={(e) => setMoreInfo(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
        </div>
      </div>
      </>
    );
  };
  
  export default FirstStepMobile;
  